import React from 'react';
import { saveAs } from 'file-saver';
import styled from 'styled-components';
import { colors } from '../../../Shared/colors';

const CsvBtn = () => {
  let data = [{
    phoneNumber: '123-456-7890',
    name: 'John Doe',
    clientType: 'Type A',
    clientOccupation: 'Engineer',
    clientRating: '5 stars',
    buyingIntent: 'High',
    classification: 'VIP',
    source: 'Referral',

  }]
  const handleDownload = () => {
    const csvHeader = [
      'PhoneNumber', 'Name', 'ClientType', 'ClientOccupation',
      'ClientRating', 'BuyingIntent', 'Classification', 'Source'
    ].join(',');

    const csvData = data.map(item => (
      [
        item.phoneNumber, item.name, item.email, item.clientType, item.clientOccupation,
        item.clientRating, item.buyingIntent, item.classification, item.source,
      ].join(',')
    )).join('\n');

    const csvBlob = new Blob([csvHeader, '\n', csvData], { type: 'text/csv' });
    saveAs(csvBlob, 'client_data.csv');
  };

  return (
    <Button onClick={handleDownload}>
      📥 Download Format
    </Button>
  );
};

export default CsvBtn;


const Button = styled.button`
  background: linear-gradient(135deg, ${colors.brown} 0%, #8B4513 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.3);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 69, 19, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`